module.exports = __webpack_public_path__ + "img/icon-biotech.51db1078.svg";